import { init, FeatureFlag } from '@goldcast/feature-flags';
import logger from '@goldcast/logger';

import store from '@/store';
import { getEnv } from '@/utils/env';

type UnauthedFeatureFlags = {
  [key in UnauthedFeatureFlagKeys]: FeatureFlag;
};

export enum UnauthedFeatureFlagKeys {
  Use_CL_Signup_Video = 'Use_CL_Signup_Video',
  Use_CL_Remotion = 'Use_CL_Remotion'
}

export const handleFlagValueChange = (flag: UnauthedFeatureFlagKeys) => (value: boolean) => {
  store.commit('unauthedFeatureFlags/updateUnauthedFeatureFlag', { flag, value });
};

export const unauthedFeatureFlags = (): UnauthedFeatureFlags => ({
  [UnauthedFeatureFlagKeys.Use_CL_Signup_Video]: {
    value: false,
    changeHandler: handleFlagValueChange(UnauthedFeatureFlagKeys.Use_CL_Signup_Video)
  },
  [UnauthedFeatureFlagKeys.Use_CL_Remotion]: {
    value: false,
    changeHandler: handleFlagValueChange(UnauthedFeatureFlagKeys.Use_CL_Remotion)
  }
});

export const initializeUnauthedFeatureFlags = (identifier: string) => {
  init(getEnv('VUE_APP_HARNESS_UNAUTH_SECRET') || '', { identifier, name: 'anonymous' }, unauthedFeatureFlags(), {
    ready: flags => {
      window.analytics.track('HarnessUnauthedFeatureFlagsReady', flags);
      Object.keys(flags).forEach(flagKey => {
        logger.addFeatureFlag(flagKey, String(flags[flagKey]));
      });
      store.commit('unauthedFeatureFlags/updateAreUnauthedFlagsLoaded', true);
    },
    change: changeInfo => {
      logger.addFeatureFlag(changeInfo.flag, String(changeInfo.value));
    },
    errorAuth: () => {
      logger.error('Error initializing unauthed feature flags');
      store.commit('unauthedFeatureFlags/updateAreUnauthedFlagsLoaded', false);
    }
  });
};
